import React, {Component} from 'react';
import ArticleTableRow from "./ArticleTableRow";

class ArticleTable extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let {
            TableRows,
            TextWhenTableRowIsChecked
        } = this.props.article;
        return (
            <table className="foodTable">
                <tr>
                    <th role="presentation"><div style={{visibility: 'hidden'}}>{'presentation'}</div></th>
                    {TableRows[0].Columns.map((row)=>{
                        return <th>
                            {row.ColumnHeader.Value}
                        </th>
                    })}
                </tr>
                {TableRows.map((row, index)=>{
                    return <ArticleTableRow row={row} text={TextWhenTableRowIsChecked.Value} key={index} index={index} />;
                })}
            </table>
        )
    }
}

export default ArticleTable;
